module.exports = __webpack_public_path__ + "static/media/visa.982efa5b.webp";